import { render } from "./PosDesk.vue?vue&type=template&id=019f5f4a"
import script from "./PosDesk.vue?vue&type=script&lang=js"
export * from "./PosDesk.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__